module.exports = __webpack_public_path__ + "img/v1-1.6776d1d2.png";